import { filter } from "../filter.js";
import { castArray } from "./castArray.js";
const someTagsFilter = tags => {
  return filter.any("document.tags", castArray(tags));
};
export { someTagsFilter };